import { Observer } from "mobx-react"
import React from "react"

import SwitchTab from "@/component/SwitchTab/SwitchTab"
import stores from "@/stores"

import styles from "../../Account.module.scss"

const PBAppToggleComponent = () => {
  const { upgradeStore } = stores

  return <Observer>{() =>
    <>
      <SwitchTab
        className={styles.appToggle}
        radioOptions={[
          {
            label: "CWILL Tracking",
            value: "parcelpanel",
          },
          {
            label: "CWILL Bundle",
            value: "bundle",
          },
        ]}
        value={upgradeStore.appType} handleRadio={(value) => {
          upgradeStore.setAppType(value)
        }}
      />
    </>
  }</Observer>
}

export default PBAppToggleComponent
